<template>
  <div class="product-configurator-option-wrapper" v-if="product.type_id =='configurable'">
    <div
      class="product-configurator-option"
      v-for="(option, index) in product.configurable_options"
      :key="index"
    >
      <div class="row">
        <label :for="'select_' + option.attribute_code" :id="'label_' + option.attribute_code" class="configurator-option-head col-xs-4" data-testid="variantsLabel">
          {{ option.label }}
        </label>

        <div class="configurator-option-content col-xs-8">
          <select
            @change="changeFilter"
            :class="option.attribute_code"
            :ref="option.attribute_code"
            :id="'select_' + option.attribute_code"
            :aria-labelledby="'label_' + option.attribute_code"
          >
            <option
              v-for="filter in getAvailableFilters[option.attribute_code]"
              :class="filter.id"
              :value="JSON.stringify(filter)"
              :key="filter.id"
              :data-id="filter.id"
            >
              {{ filter.label }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAvailableFiltersByProduct, getSelectedFiltersByProduct } from '@vue-storefront/core/modules/catalog/helpers/filters'
import { mapGetters } from 'vuex'

export default {
  props: {
    product: Object
  },
  computed: {
    ...mapGetters({
      getCurrentProductConfiguration: 'product/getCurrentProductConfiguration'
    }),
    getAvailableFilters () {
      return getAvailableFiltersByProduct(this.product)
    },
    getSelectedFilters () {
      return getSelectedFiltersByProduct(this.product, this.getCurrentProductConfiguration)
    }
  },
  mounted () {
    this.refreshSelectedOptions();
  },
  updated () {
    this.refreshSelectedOptions();
  },
  methods: {
    refreshSelectedOptions () {
      const filters = this.getSelectedFilters

      for (const filter in filters) {
        const select = this.$refs[filter][0];
        Array.from(select.options).forEach((option, index) => {
          if (parseInt(option.dataset.id) === parseInt(filters[filter].id)) {
            select.selectedIndex = index
          }
        })
      }
    },
    changeFilter (event) {
      const variant = JSON.parse(event.target.value);
      this.$bus.$emit(
        'filter-changed-product',
        Object.assign({ attribute_code: variant.type }, variant)
      )
      // this.$parent.getQuantity()
    }
  }
}
</script>
